import { render, staticRenderFns } from "./park-parking-space.vue?vue&type=template&id=3137f57b&scoped=true&"
import script from "./park-parking-space.vue?vue&type=script&lang=js&"
export * from "./park-parking-space.vue?vue&type=script&lang=js&"
import style0 from "./park-parking-space.vue?vue&type=style&index=0&id=3137f57b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137f57b",
  null
  
)

export default component.exports